export function decodeMVCCookiesToJson(b64) {
  if (!b64 || typeof b64 !== "string") return {};

  try {
    // Base64 decode
    const decoded = Buffer.from(b64, "base64").toString("utf-8");

    // Ayraç ile parçala
    const parts = decoded.split("+_-;");

    // Boş alanları at ve nesne olarak döndür
    const obj = {};
    if (parts[1]) obj.id = parts[1];
    if (parts[2]) obj.currency = parts[2];
    if (parts[3]) obj.languageCode = parts[3];
    if (parts[4]) obj.countryCode = parts[4];
    if (parts[7]) obj.numberField = Number(parts[7]);
    if (parts[12]) obj.isActive = parts[12].toLowerCase() === "true";
    if (parts[17]) obj.lastNumber = Number(parts[17]);

    return obj;
  } catch (err) {
    console.error("Base64 decode error:", err);
    return {};
  }
}

/**
 * TS5009 cookie'sinden ilk % işaretinden önceki değeri alır
 * @param {string} b64 - Base64 encoded cookie değeri
 * @returns {string} - İlk % işaretinden önceki değer
 */
export function getTS5009Value(b64) {
  if (!b64 || typeof b64 !== "string") return "";

  try {
    // Base64 decode
    const decoded = Buffer.from(b64, "base64").toString("utf-8");

    // İlk % işaretinden önceki kısmı al
    const percentIndex = decoded.indexOf("%");
    if (percentIndex !== -1) {
      return decoded.substring(0, percentIndex);
    }

    return decoded; // % işareti yoksa tüm string'i döndür
  } catch (err) {
    console.error("TS5009 decode error:", err);
    return "";
  }
}

/**
 * TL5009 cookie'sinden ; ile + arasındaki değeri alır
 * @param {string} b64 - Base64 encoded cookie değeri
 * @returns {string} - ; ile + arasındaki değer
 */
export function getTL5009Value(b64) {
  if (!b64 || typeof b64 !== "string") return "";

  try {
    // Base64 decode
    const decoded = Buffer.from(b64, "base64").toString("utf-8");

    // ; işaretinden sonraki kısmı al
    const semicolonIndex = decoded.indexOf(";");
    if (semicolonIndex !== -1) {
      const afterSemicolon = decoded.substring(semicolonIndex + 1);
      // İlk + işaretini bul
      const plusIndex = afterSemicolon.indexOf("+");
      if (plusIndex !== -1) {
        // ; ile + arasındaki değeri al
        return afterSemicolon.substring(0, plusIndex);
      }
      // + işareti yoksa ; sonrası tüm değeri al
      return afterSemicolon;
    }

    return ""; // ; işareti yoksa boş string döndür
  } catch (err) {
    console.error("TL5009 decode error:", err);
    return "";
  }
}

/**
 * T5009 cookie'sini base64 decode eder, "%3" ile böler ve
 * ilk iki değeri { sessionId, sessionToken } olarak döndürür.
 * @param {string} b64 - Base64 encoded cookie değeri
 * @returns {{ sessionId: string, sessionToken: string }}
 */
export function getT5009Data(b64) {
  if (!b64 || typeof b64 !== "string") {
    return { sessionId: "", sessionToken: "" };
  }

  try {
    const decoded = Buffer.from(b64, "base64").toString("utf-8");
    const parts = decoded.split("%3");

    const sessionId = parts[0] ?? "";
    const sessionToken = parts[1] ?? "";

    return { sessionId, sessionToken };
  } catch (err) {
    console.error("T5009 decode error:", err);
    return { sessionId: "", sessionToken: "" };
  }
}
